var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.CanSeeCampaignDashboard)?_c('Dashboard'):_c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v(" "+_vm._s(_vm.$t("template.no_access", "You don`t have access to this page. Failed ACL: {acl}", { acl: "SeeCampaignDashboard", }))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }